import { PropsWithChildren } from "react";

/**
 * A container wrapper that positions the child
 * elements in the center of the screen above
 * the rest of the page elements.
 *
 * Root child element should be positioned relatively.
 *
 * @param onClick   The event handler for when the modal background is clicked
 * @param className The classname to apply to the modal background
 */
const FullscreenModalLayout = ({
  children,
  className,
  containerClassName,
  onClick
}: PropsWithChildren<{
  className?: string;
  containerClassName?: string;
  onClick?: () => void;
}>) => {
  return (
    <div
      className={
        "absolute bottom-0 right-0 z-40 flex h-full w-full justify-center " +
        containerClassName
      }
    >
      {/* Hidden div used to apply background effects */}
      <div
        className={"absolute h-full w-full " + className}
        onClick={onClick}
      ></div>

      {/* Modal window */}
      {children}
    </div>
  );
};

export default FullscreenModalLayout;
